const profile = {
    name: 'Nom',
    avatar: 'Avatar',
    givenName: 'Prénom',
    familyName: 'Nom de famille',
    middleName: 'Deuxième prénom',
    fullname: 'Nom complet',
    nickname: 'Surnom',
    preferredUsername: "Nom d'utilisateur préféré",
    profile: 'Profil',
    website: 'Site web',
    gender: 'Genre',
    birthdate: 'Date de naissance',
    zoneinfo: 'Fuseau horaire',
    locale: 'Langue',
    address: {
        formatted: 'Adresse',
        streetAddress: 'Adresse',
        locality: 'Ville',
        region: 'État/Province',
        postalCode: 'Code postal',
        country: 'Pays',
    },
    gender_options: {
        female: 'Femme',
        male: 'Homme',
        prefer_not_to_say: 'Préfère ne pas dire',
    },
    checkbox_value: {
        checked: 'Oui',
        unchecked: 'Non',
    },
};
export default Object.freeze(profile);
